import React from "react";
import { Box, Label, CheckBox, NullCommand, ErrorExclamationView, theme } from "Application";
import { TableList, TableBox } from "./SessionReport.styles";
import { IStudentSessionReportViewModel } from "Views/Students/Student/StudentReports/Form/Interfaces/IStudentSessionReportViewModel";
import { observer } from "mobx-react-lite";
import styled from "@emotion/styled";

const LabelContainer = styled.div`
    display: flex;
`;

export const SessionReportWellbeing: React.FC<{ viewModel: IStudentSessionReportViewModel }> = observer(({ viewModel }) => (
    <Box flexBox flexDirection={"column"} gap="20px">
        <Box>
            <LabelContainer>
                <Label fontStyle="h2">Wellbeing*</Label>
                <ErrorExclamationView haveError={viewModel.showWellbeingError} validationMessage={() => viewModel.getError("wellbeingId")} />
            </LabelContainer>
            <Label fontStyle="field">
                Wellbeing focuses on the extent of which young people feel at ease, act spontaneously, show vitality, and self-confidence. It is a crucial component of emotional
                intelligence and good mental health.
            </Label>
        </Box>

        <Box bg={theme.palette.common.lightGrey} border="1px solid #D4D4D4">
            <Box flexBox flexDirection={"column"} gap="10px">
                <TableList>
                    {viewModel.model.wellbeing.map((item) => (
                        <TableBox color={item.displayColor} key={item.KEY}>
                            <CheckBox
                                key={item.KEY}
                                command={new NullCommand()}
                                onChange={() => viewModel.updateWellbeingCommand.execute(item.id)}
                                displayName={item.severityLevel}
                                value={() => viewModel.model.wellbeingId === item.id}
                            />
                            <Box>
                                <Label style={{ color: `${item.displayColor}` }}>{item.severityLevel}</Label>
                                <Label>{item.wellBeingDescription}</Label>
                            </Box>
                        </TableBox>
                    ))}
                </TableList>
            </Box>
        </Box>
    </Box>
));
